import { useEffect, useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  makeStyles,
  Box,
  Button,
} from "@material-ui/core";

import Api from "lib/api/httpRequestHelper";

import HeaderClientes from "components/_refactor/headers/clients";

import componentStyles from "assets/theme/views";

import UtilsFncs from "utils/UtilsFncs";

import GeneralData from "./dados-gerais/page";
import IncludeProducts from "./incluir-produtos/page";
import TargetAudience from "./publico-alvo/page";

import {
  setCurrentStep,
  resetVitrineData,
} from "redux/reducers/criarVitrineReducer";

const steps = [
  {
    label: "Dados gerais",
    component: GeneralData,
  },
  {
    label: "Inclusão de produtos",
    component: IncludeProducts,
  },
  {
    label: "Público alvo | Representantes",
    component: TargetAudience,
  },
];

const useStyles = makeStyles(componentStyles);

export default function CriarVitrine() {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();

  const { currentStep, formData, selectedProducts, representatives } =
    useSelector((state) => state.criarVitrine);

  const stepIsReadyToNext = () => {
    if (currentStep === 0) {
      return (
        !!formData.brand?.value &&
        !!(
          (formData.initialDate && formData.finalDate) ||
          formData.untilSoldOut
        ) &&
        !!formData.name &&
        !!formData.paymentCondition?.IdCondicaoPagamento &&
        !!(formData.byLine || formData.byOrder)
      );
    }

    if (currentStep === 1) {
      return selectedProducts.length > 0;
    }

    if (currentStep === 2) {
      return representatives.length > 0;
    }

    return false;
  };

  const handleCreateShowcase = useCallback(async () => {
    setLoading(true);
    try {
      const response = await Api.post(
        "create-virtual-showcase-b2b",
        "showcaseB2B",
        {
          nome: formData.name,
          descricao: formData.description,
          ativo: true,
          marca: formData.brand?.value,
          dataVigenciaInicio: formData.untilSoldOut
            ? null
            : UtilsFncs.ConvertDateFormat(formData?.initialDate, "-", "-"),
          dataVigenciaFim: formData.untilSoldOut
            ? null
            : UtilsFncs.ConvertDateFormat(formData?.finalDate, "-", "-"),
          finalizarEstoque: formData.untilSoldOut,
          idCondicaoPagamento: formData.paymentCondition?.IdCondicaoPagamento,
          prazoMedio: `${formData.paymentCondition?.PrazoMedio ?? ""} dias`,
          valorMinimo: formData.minimumValue,
          duplicataMinima: formData.minimumInvoice,
          quantidadeMinimaPedido: formData.minimumQuantityPerOrder,
          porLinha: formData.byLine,
          porPedido: formData.byOrder,
          itensProduto: selectedProducts.map((product) => ({
            idProduto: product.Codigo,
            descontoPercentual: product?.Desconto || 0,
          })),
        },
        true
      );

      await Api.post(
        "create-virtual-b2b-representative",
        "showcaseB2B",
        {
          idVitrineVirtualB2b: response.Result.IdVitrineVirtualB2b,
          idsRepresentante: representatives
            .map((representative) => representative.Id)
            .toString(),
        },
        true
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [formData, selectedProducts, representatives]);

  const handleNextStep = useCallback(async () => {
    if (currentStep === 2) {
      await handleCreateShowcase();

      dispatch(resetVitrineData());
      history.push("/admin/visualizar-vitrines-b2b");
    } else {
      dispatch(setCurrentStep(currentStep + 1));
    }
  }, [currentStep, handleCreateShowcase, dispatch, history]);

  const handlePreviousStep = useCallback(() => {
    if (currentStep === 0) {
      dispatch(resetVitrineData());
      history.push("/admin/visualizar-vitrines-b2b");
    } else {
      dispatch(setCurrentStep(currentStep - 1));
    }
  }, [currentStep, dispatch, history]);

  useEffect(() => {
    dispatch(resetVitrineData());
  }, [dispatch]);

  return (
    <>
      <HeaderClientes section="Pré-pedido" subsection="Vitrine B2B" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <Card classes={{ root: classes.cardRoot }}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h2">
                  Criação da Vitrine – {steps[currentStep].label}
                </Typography>
              </Grid>
            </Grid>
            {(() => {
              const Component = steps[currentStep].component;
              return <Component />;
            })()}
            <Box
              display="flex"
              justifyContent="flex-start"
              mt="40px"
              height="50px"
              style={{ gap: "20px" }}
            >
              <Button
                variant="contained"
                color="primary"
                style={{ height: "50px" }}
                loading={loading}
                onClick={handleNextStep}
                disabled={!stepIsReadyToNext()}
              >
                {currentStep === 2 ? "Enviar" : "Avançar"}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                style={{ height: "50px" }}
                onClick={handlePreviousStep}
              >
                {currentStep === 0 ? "Cancelar" : "Voltar"}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </>
  );
}
